import dayjs from "dayjs";
import dayjsTZ from "../../../utils/dayjs";

export const startPrevMonth = () => {
  const startMonth = dayjsTZ().subtract(1, "months").format("MMMM");
  const values = {
    Mars: 1,
    Nëntor: 2,
  };
  let date = dayjsTZ(dayjsTZ().startOf("month")).subtract(1, "months");
  if (values[startMonth]) {
    date = dayjsTZ(date.utcOffset(values[startMonth], true));
  }
  return date;
};

export const intervals = {
  today: [dayjsTZ().startOf("day"), dayjsTZ().endOf("day")],
  yesterday: [
    dayjsTZ().subtract(1, "days").startOf("day"),
    dayjsTZ().subtract(1, "days").endOf("day"),
  ],
  thisWeek: [dayjsTZ().startOf("week"), dayjsTZ().endOf("week")],
  thisMonth: [dayjsTZ().startOf("month"), dayjsTZ().endOf("month")],
  previousMonth: [
    startPrevMonth(),
    dayjsTZ().subtract(1, "months").endOf("month"),
  ],
  thisYear: [dayjsTZ().startOf("year"), dayjsTZ().endOf("year")],
};
